import styled from 'styled-components'

export const Container = styled.div<{ backgroundColor?: string; isDragging?: boolean }>`
  overflow: hidden;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  height: 56px;

  padding: 8px;
  box-sizing: border-box;

  border-radius: 6px;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.95) 100%),
    ${({ backgroundColor }) => backgroundColor || 'white'};

  /* Raised */
  box-shadow: 0px 1px 2px -1px rgba(0, 0, 0, 0.1), 0px 2px 3px 0px rgba(0, 0, 0, 0.1);

  &.tooltip {
    height: 102px;
    min-width: 300px;

    padding: 12px 16px;

    border: 1px solid ${({ backgroundColor }) => backgroundColor};
    /* Overlay */
    box-shadow: 0px 15px 25px 0px rgba(0, 0, 0, 0.07), 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
  }

  &.list,
  &.calendar {
    cursor: ${({ isDragging }) => (isDragging ? 'grabbing' : 'grab')};

    div,
    label,
    img {
      cursor: ${({ isDragging }) => (isDragging ? 'grabbing' : 'grab')};
    }
  }
`

export const HeaderContainer = styled.label<{ color?: string }>`
  width: 100%;
  overflow: hidden;

  display: flex;
  flex-direction: row;
  align-items: center;

  gap: 8px;
`

export const LabelTaskTemplate = styled.label<{ color: string }>`
  width: 100%;
  overflow: hidden;

  background: linear-gradient(0deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.4) 100%), ${({ color }) => color};

  -webkit-background-clip: text;
  -moz-background-clip: text;
  background-clip: text;
  color: transparent;

  text-overflow: ellipsis;
  white-space: nowrap;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 78.571% */
`

export const ActionIconImg = styled.img`
  padding: 4px;
  box-sizing: border-box;

  margin-left: 8px;
  cursor: pointer;
`

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;

  gap: 8px;
`

export const LabelCompany = styled.label`
  overflow: hidden;
  color: var(--foreground-neutral-faded, #4d5874);

  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
`

export const SummaryContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  gap: 8px;
`

export const ValueContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`

export const ValueLabel = styled.div`
  color: var(--foreground-neutral-faded, #4d5874);

  /* Caption 1/Regular */
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
`

export const IconImg = styled.img`
  width: 12px;
  height: 12px;
`
